import BannerImageIADR from "../../statics/img/posters-banner-IADR.png";
import BannerImageSEAADE from "../../statics/img/posters-banner-SEAADE.jpg";
import Collaborators from "../../components/Collaborators";
import Container from "../../components/Container";
import ContainerDivider from "../../components/ContainerDivider";
import Footer from "../../components/Footer";
import Image from "../../components/Image";
import ListHeader from "../../components/ListHeader";
import Navbar from "../../components/Navbar";
import Ratio from "../../components/Ratio";
import React from "react";
import Spacer from "../../components/Spacer";
import SubscriptionSection from "../../components/SubscriptionSection";
import VerticalThumbnailGrid from "../../components/VerticalThumbnailGrid";
import useEvent from "../../hooks/useEvent";
import usePosters from "../../hooks/usePosters";

const Posters = () => {
  const event = useEvent();
  const { posters, loading } = usePosters();
  const IADRPosters = posters.filter((poster) => poster.event === "IADR");
  const SEAADEPosters = posters.filter((poster) => poster.event === "SEAADE");

  const IADRPostersGroups = [
    {
      header: "Posters",
      title: "Poster Session 1",
      items: IADRPosters.filter((poster) => poster.category === 1),
    },
    {
      header: "Posters",
      title: "Poster Session 2",
      items: IADRPosters.filter((poster) => poster.category === 2),
    },
    {
      header: "Posters",
      title: "Unilever Senior",
      items: IADRPosters.filter((poster) => poster.category === 3),
    },
    {
      header: "Posters",
      title: "Poster Session 4",
      items: IADRPosters.filter((poster) => poster.category === 4),
    },
  ];

  const SEAADEPostersGroups = [
    {
      header: "Posters",
      title: "Competition Session 1",
      items: SEAADEPosters.filter((poster) => poster.category === 1),
    },
    {
      header: "Posters",
      title: "Competition Session 2",
      items: SEAADEPosters.filter((poster) => poster.category === 2),
    },
    {
      header: "Posters",
      title: "Competition Session 3",
      items: SEAADEPosters.filter((poster) => poster.category === 3),
    },
    {
      header: "Posters",
      title: "Competition Session 4",
      items: SEAADEPosters.filter((poster) => poster.category === 4),
    },
    {
      header: "Posters",
      title: "Competition Session 5",
      items: SEAADEPosters.filter((poster) => poster.category === 5),
    },
    {
      header: "Posters",
      title: "Competition Session 6",
      items: SEAADEPosters.filter((poster) => poster.category === 6),
    },
  ];

  const currentPostersGroups =
    event === "IADR"
      ? IADRPostersGroups
      : event === "SEAADE"
      ? SEAADEPostersGroups
      : [];

  const hasPosters = currentPostersGroups.some(
    (group) => group.items.length > 0
  );

  return (
    <div className="PostersPage">
      <Navbar />

      <Ratio w={32} h={9}>
        {event === "IADR" ? (
          <Image src={BannerImageIADR} />
        ) : event === "SEAADE" ? (
          <Image src={BannerImageSEAADE} />
        ) : null}
      </Ratio>

      <div className="mt-12">
        <Container>
          {!loading && !hasPosters ? (
            <div className="py-24 text-center">
              <h2 className="text-2xl text-gray-700">
                Poster presentations are not available in this demo
              </h2>
              <p className="max-w-xl mx-auto mt-4 text-gray-500">
                This is an archived showcase of the SEAADE-IADR-SEA 2020 virtual
                conference. The original poster files are no longer hosted, so
                they cannot be displayed here.
              </p>
            </div>
          ) : (
            <div className="space-y-8">
              {currentPostersGroups.map((group, key) => {
                return (
                  <div className="space-y-4" key={key}>
                    <ListHeader header={group.header} title={group.title} />
                    <VerticalThumbnailGrid
                      items={group.items.map((item: any) => {
                        return {
                          cover: item.code,
                          title: item.title,
                          subtitle: item.author,
                          link: `/${event}/posters/${item.code}`,
                          // image: item.image,
                        };
                      })}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </Container>
      </div>

      <Spacer>
        <ContainerDivider />
        <Collaborators />
      </Spacer>

      <SubscriptionSection />
      <Footer />
    </div>
  );
};

export default Posters;
